<script>
import { GlLoadingIcon } from '@gitlab/ui';
import { kebabCase } from 'lodash-es';

export default {
  components: {
    GlLoadingIcon,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: false,
      default: '',
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
    topBorderEnabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    showAsHeader: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    valueLabelSelector() {
      return `${kebabCase(this.label)}-value`;
    },
    labelClass() {
      return this.showAsHeader ? 'gl-h3' : 'gl-my-3';
    },
  },
};
</script>

<template>
  <div>
    <hr v-if="topBorderEnabled" class="gl-my-5" />
    <div class="gl-flex gl-justify-between">
      <div :class="labelClass" data-testid="label">{{ label }}</div>
      <div class="gl-my-auto">
        <gl-loading-icon v-if="isLoading" />
        <div
          v-else-if="value"
          class="gl-text-align-right gl-text-lg gl-leading-24"
          :data-testid="valueLabelSelector"
        >
          {{ value }}
        </div>
      </div>
    </div>
    <div v-if="description && !isLoading" data-testid="description" class="text-muted gl-mt-3">
      {{ description }}
    </div>
  </div>
</template>
